var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    scopedSlots: _vm._u([{
      key: "contentsHead",
      fn: function () {
        return [_c('sub-head-primary', {
          attrs: {
            "itemTitle": "사업안내",
            "tabActive": "특장점 안내",
            "bg": "/images/sub/business/visual.jpg"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_vm._v("사업안내")];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section-primary', {
    staticClass: "page-section--first page-section--last",
    attrs: {
      "titWrapClass": "text-center"
    },
    scopedSlots: _vm._u([{
      key: "tit",
      fn: function () {
        return [_vm._v("특장점 안내")];
      },
      proxy: true
    }])
  }, [_c('v-row', {
    staticClass: "row--xxs"
  }, [_vm._l(_vm.items, function (item, index) {
    return [_c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "sm": "6",
        "xl": "3"
      }
    }, [_c('v-img', {
      staticClass: "feature-icon",
      attrs: {
        "src": item.icon
      }
    }), _c('tit', {
      staticClass: "tit--sm text-center mb-20px mb-md-34px"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _c('v-sheet', {
      attrs: {
        "color": "grey lighten-5 pa-16px feature-sheet"
      }
    }, [_c('txt', {
      staticClass: "text-pre-wrap txt--lg grey--text break-keep line-height-15"
    }, [_vm._l(item.children, function (child, index) {
      return [_c('v-row', {
        key: index,
        staticClass: "row--xxs"
      }, [_c('v-col', {
        attrs: {
          "cols": "auto"
        }
      }, [_vm._v("·")]), _c('v-col', [_vm._v(_vm._s(child))])], 1)];
    })], 2)], 1)], 1)];
  })], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }